import { render, staticRenderFns } from "./ChatbotButton.vue?vue&type=template&id=0016ef06&scoped=true&"
import script from "./ChatbotButton.vue?vue&type=script&lang=js&"
export * from "./ChatbotButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotButton.vue?vue&type=style&index=0&id=0016ef06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0016ef06",
  null
  
)

export default component.exports